'use client';

import { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

interface QuickCalculatorAccessProps {
  onCalculatorOpen?: () => void;
}

const QuickCalculatorAccess = ({ onCalculatorOpen }: QuickCalculatorAccessProps) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleClick = () => {
    const calculatorSection = document.getElementById('calculator');
    if (calculatorSection) {
      const offsetPosition = calculatorSection.offsetTop - 80;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }

    if (onCalculatorOpen) {
      onCalculatorOpen();
    }
  };

  return (
    <>
      <button
        onClick={handleClick}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        className="lg:hidden fixed bottom-24 right-6 z-30 flex items-center justify-center w-14 h-14 bg-secondary text-secondary-foreground rounded-full shadow-cta transition-all duration-250 hover:scale-110 hover:shadow-lg"
        aria-label="Otwórz kalkulator"
      >
        <Icon name="CalculatorIcon" size={24} variant="outline" />
      </button>

      <div className="hidden lg:block fixed bottom-8 right-8 z-30">
        <button
          onClick={handleClick}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          className="group relative flex items-center gap-3 px-6 py-4 bg-secondary text-secondary-foreground rounded-lg shadow-cta transition-all duration-250 hover:bg-secondary/90 hover:shadow-lg hover:scale-105"
        >
          <Icon name="CalculatorIcon" size={24} variant="outline" />
          <span className="font-body font-semibold">Kalkulator kredytowy</span>

          {isHovered && (
            <div className="absolute bottom-full right-0 mb-2 px-4 py-2 bg-card border border-border rounded-lg shadow-card whitespace-nowrap animate-fade-in">
              <span className="text-sm font-body text-foreground">
                Oblicz swoją ratę w 30 sekund
              </span>
            </div>
          )}
        </button>
      </div>
    </>
  );
};

export default QuickCalculatorAccess;